import { render } from "./GetAppView.vue?vue&type=template&id=61cab5ac"
const script = {}

import "./GetAppView.vue?vue&type=style&index=0&id=61cab5ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__